/* tslint:disable */
/* eslint-disable */
/**
 * Track API
 * The Track API provides access to SPiDRs and Security Focuses.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const TaskState = {
    NotStarted: 'Not Started',
    InProgress: 'In Progress',
    Done: 'Done',
    Rejected: 'Rejected'
};
export function TaskStateFromJSON(json) {
    return TaskStateFromJSONTyped(json, false);
}
export function TaskStateFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function TaskStateToJSON(value) {
    return value;
}
